import {
  AsyncInteractor,
  IBlocAsyncInteractor
} from "@kernel/frontend-react-app";
import { ConfigService } from "../../services";

export interface LoadConfigService {
  loadConfig(key: string): Promise<unknown[]>;
}

export interface LoadConfigInteractorProps {
  keys: string[];
}

export class LoadConfigInteractor
  extends AsyncInteractor<LoadConfigService, LoadConfigInteractorProps, unknown>
  implements IBlocAsyncInteractor<unknown>
{
  public async execute(props: LoadConfigInteractorProps): Promise<unknown> {
    let objectConfig: object = {};
    for (const configKey of props.keys) {
      objectConfig = {
        ...objectConfig,
        [configKey]: await this.service.loadConfig(configKey)
      };
    }
    return objectConfig;
  }

  public static create() {
    const service = new ConfigService();
    return new LoadConfigInteractor(service);
  }
}
